import React from "react";
export function FacebookMessengerColored({
  size = 20
}) {
  return /*#__PURE__*/React.createElement("svg", {
    width: `${size}px`,
    height: `${size}px`,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.0002 4.16675C14.0627 4.16675 5.2085 12.6042 5.2085 22.9167C5.2085 28.3334 7.60433 33.1251 11.4585 36.5626V45.8334L19.5835 40.9376C21.2502 41.3542 23.1252 41.6667 25.0002 41.6667C35.9377 41.6667 44.7918 33.2292 44.7918 22.9167C44.7918 12.6042 35.9377 4.16675 25.0002 4.16675Z",
    fill: "#448AFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5 29.1666L22.9167 17.7083L28.125 22.9166L37.5 17.7083L27.0833 29.1666L21.875 23.9583L12.5 29.1666Z",
    fill: "white"
  }));
}
//# sourceMappingURL=FacebookMessengerColored.js.map